import type * as React from 'react';
import Spark from '../../components/Spark/lazy';
import { useAppContext } from '../../hooks/useAppContext';

const HeaderSparks: React.FC = () => {
    const { user } = useAppContext();
    const { company } = user;

    return user.isHR && company.onAutomatedBilling ? <Spark story="AUTOMATED_BILLING" type="promptToCheckout" /> : null;
};

export default HeaderSparks;
